package org.vreo.devicehub.features.settings.presentation.settings

import org.vreo.devicehub.features.core.domain.device.device.anprDeviceSettings.AnprDeviceUpdateReleaseType
import org.vreo.devicehub.features.core.presentation.UiText

/**
 * Settings ui state
 */
data class SettingsState(
    // State of view model.
    val isLoading: Boolean = false,
    val error: UiText? = null,
    val isDeviceActive: Boolean = false,
    val isAdmin: Boolean = false,

    // Limits, those should not be updated by user of view model.
    val brightnessLimitMax: Float = 255.0f,
    val brightnessLimitMini: Float = 30.0f,
    val exposureTimeLimitMax: Float = 1100.0f,
    val exposureTimeLimitMini: Float = 40.0f,
    val gainLimitMax: Float = 25.0f,
    val gainLimitMini: Float = 0.0f,

    // User selected values.
    val selectedFrameRotationIndex: Int = 0,
    val brightness: String = "",

    // Zoom and focus
    val zoomEnabled: Boolean = false,
    val focusEnabled: Boolean = false,

    val zoom: Float = 0f,
    val zoomMini: Float = 0f,
    val zoomMax: Float = 100f,

    val focus: Float = 0f,
    val focusMini: Float = 0f,
    val focusMax: Float = 100f,

    // Exposure
    val exposureTimeMax: String = "",
    val exposureTimeMini: String = "",
    val gainMax: String = "",
    val gainMini: String = "",

    val selectedUpdateReleaseTypeIndex: Int = AnprDeviceUpdateReleaseType.STABLE.ordinal
)
